import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';



@Component({
    selector: 'btn-cell-renderer-edit-delete',
    template: 
		`<em>
			<div class="info-btn">
			<i *ngIf="enableEdit" title="Edit" class="fas fa-pencil custom-icon"  (click)="btnClickedHandler('edit')"></i>      
			<i *ngIf="enableDelete" title="Details" class="fas fa-trash-alt custom-icon" (click)="btnClickedHandler('delete')"></i>    
			</div>
		</em>`
    ,
	styles: [`
        .info-btn{
            display: flex;
            gap: 0.8rem;
            color: #fff;
            cursor: pointer;
        }

		::ng-deep .custom-icon {
			/* background: linear-gradient(#000, rgb(49, 49, 49)); */
			border: 1px solid #676A6E;
			padding: 4px 4px 4px 4px;
			/* color: #fff; */
			cursor: pointer;
			background: transparent linear-gradient(180deg, #ffffff 0%, #e9f0f3 100%) 0% 0% no-repeat padding-box;
			opacity: 1;
			font: normal normal bold 10px;
			color: #676a6e;
		}
    `],
    standalone: false // NOSONAR
})
export class BtnCellRendererEditDelete implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		return false;
	}

	private params: any;
	pageName;
	enableEdit: boolean = false;
	enableDelete: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//tier
		if (this.pageName == "investigation") { // NOSONAR
			this.enableEdit = true;
		}else if (this.pageName == "home"){ // NOSONAR
			this.enableEdit = true;
			this.enableDelete = true;
		}

		//reasonId
		if (this.params.colDef.field == "reasonId_editdelete") { // NOSONAR
			this.enableEdit = true;
			this.enableDelete = true;
		}

		//targets
		if (this.params.colDef.field == "targetsActions") { // NOSONAR
			this.enableEdit = true;
			this.enableDelete = true;
		}

		//reasonId
		if (this.params.colDef.field == "rootCause_editdelete") { // NOSONAR
			this.enableEdit = true;
			this.enableDelete = true;
		}



	}

	btnClickedHandler(action) {

		if (action == 'edit') { // NOSONAR
			this.params.context.componentParent.editTemplateRow(this.params.data);
		}
		if (action == 'delete') { // NOSONAR
			this.params.context.componentParent.deleteTemplateRow(this.params.data);
		}
	}

	ngOnDestroy() {
		console.info('something')
	}
}
